module.exports = __webpack_public_path__ + "5054c726071b425967dfea14053f329b.png";